/**
 * Check if location in Ontario
 *
 * @param {object} params
 * @param {string} params.location
 * @param {boolean} params.isAddress
 * @param {Function} params.findByAddress
 * @param {Function} params.findByLatLng
 * @returns {Promise<boolean>}
 */
export const locationIsInOntario = async ({
  location,
  isAddress,
  findByAddress,
  findByLatLng,
}) => {
  try {
    if (
      typeof findByLatLng !== "function" ||
      typeof findByAddress !== "function"
    ) {
      throw new Error(
        "Geocoding functions (findByLatLng, findByAddress) were not provided."
      );
    }

    const promise = isAddress
      ? findByAddress(location)
      : findByLatLng(location);
    const { results, status } = await promise;
    if (status !== "OK") {
      return false;
    }
    return !!results?.some(
      (result) =>
        result.address_components.some(
          (address) =>
            address.types.includes("administrative_area_level_1") &&
            address.short_name === "ON"
        ) &&
        result.address_components.some(
          (address) =>
            address.types.includes("country") && address.short_name === "CA"
        )
    );
  } catch (error) {
    console.error("Geocoding failed:", error);
    return false;
  }
};
